import React, { useContext, useEffect, useState } from 'react'
import { Button, Card, CardBody, Col, Input, Row } from 'reactstrap'
import toastr from 'toastr'
import ApiService from '../../../data/services/ApiService'
import { GeneralContext } from '../../../context/'

const STORAGE_BASE_URL = 'https://storage.googleapis.com/canvasexpress'
const STOREFRONT_BASE_URL = 'https://canvasexpress.com.mx'

// Legacy mockups are Gatsby-relative paths and cannot be resolved from the backoffice origin.
const resolveMockupImageUrl = (item = {}) => {
    if (item.mockupImagePath) return `${STORAGE_BASE_URL}/${String(item.mockupImagePath).replace(/^\/+/, '')}`
    if (!item.mockupImage) return ''
    if (/^https?:\/\//i.test(item.mockupImage)) return item.mockupImage
    return `${STOREFRONT_BASE_URL}/${String(item.mockupImage).replace(/^\/+/, '')}`
}

const PersonalizationTemplatesManager = () => {
    const { setLoading } = useContext(GeneralContext)
    const [items, setItems] = useState([])
    const [pending, setPending] = useState({})

    const load = async () => {
        try {
            setLoading(true)
            const response = await ApiService.getPersonalizationTemplates()
            const single = response.data.singleOption || { slug: 'single', name: 'Una imagen personalizada', mockupImage: '/assets/images/personalizados/mockups/single-personalizado-mockup.jpg' }
            setItems([{ ...single, id: 'single' }, ...(response.data.templates || [])])
        } catch (error) {
            toastr.error('No pude cargar los mockups', 'Error')
        } finally { setLoading(false) }
    }

    useEffect(() => { load() }, []) // eslint-disable-line

    const chooseFile = (key, file) => {
        if (!file) return
        if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
            toastr.error('Solo se aceptan JPG, PNG o WEBP', 'Error')
            return
        }
        setPending(current => ({ ...current, [key]: { file, preview: URL.createObjectURL(file) } }))
    }

    const save = async item => {
        const selected = pending[item.id]
        if (!selected) return
        try {
            setLoading(true)
            const data = new FormData()
            data.append('file', selected.file)
            const upload = await ApiService.uploadPersonalizationMockup(data)
            await ApiService.updatePersonalizationMockup(item.id, { mockupImage: upload.data.url, mockupImagePath: upload.data.path })
            URL.revokeObjectURL(selected.preview)
            setPending(current => { const next = { ...current }; delete next[item.id]; return next })
            toastr.success('Mockup actualizado', 'Éxito')
            await load()
        } catch (error) {
            toastr.error(error.response?.data?.message || 'No pude actualizar el mockup', 'Error')
        } finally { setLoading(false) }
    }

    return <Row>{items.map(item => {
        const selected = pending[item.id]
        return <Col lg={4} md={6} xs={12} key={item.id} className="mb-3">
            <Card className="h-100"><CardBody>
                <div style={{ height: 220, background: '#f4f4f4', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                    {(selected?.preview || resolveMockupImageUrl(item)) && <img src={selected?.preview || resolveMockupImageUrl(item)} alt={item.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
                </div>
                <h5 className="mt-3 mb-1">{item.name}</h5><small className="text-muted">{item.slug}</small>
                <Input className="mt-3" type="file" accept="image/jpeg,image/png,image/webp" onChange={event => chooseFile(item.id, event.target.files?.[0])} />
                <Button color="primary" className="mt-2" disabled={!selected} onClick={() => save(item)}>Reemplazar mockup</Button>
            </CardBody></Card>
        </Col>
    })}</Row>
}

export default PersonalizationTemplatesManager
